/**
 * Speaking-default Content tab: scroll region + title/description + border-t page slot.
 */

import * as React from 'react';
import { cn } from '../lib/utils';
import {
    CompositeEditTitleDescription,
    type CompositeEditTitleDescriptionProps,
} from './CompositeEditTitleDescription';

type CompositeEditContentTabShared = {
    /** Semantic prefix — `{prefix}-content` and `{prefix}-page` */
    prefix: string;
    className?: string;
    metaClassName?: string;
    pageClassName?: string;
    page: React.ReactNode;
};

export type CompositeEditContentTabProps =
    | (CompositeEditContentTabShared & {
          /** Custom header region (replaces title + description block). */
          meta: React.ReactNode;
      })
    | (CompositeEditContentTabShared &
          Omit<CompositeEditTitleDescriptionProps, 'className'>);

export function CompositeEditContentTab(props: CompositeEditContentTabProps): React.ReactElement {
    const { prefix, className, pageClassName, page } = props;
    const metaSection =
        'meta' in props && props.meta != null ? (
            props.meta
        ) : (
            <CompositeEditTitleDescription
                title={props.title}
                description={props.description}
                disabled={props.disabled}
                descriptionAsInput={props.descriptionAsInput}
                titleInputClassName={props.titleInputClassName}
                descriptionInputClassName={props.descriptionInputClassName}
                className={props.metaClassName}
            />
        );

    return (
        <div
            className={cn(
                `${prefix}-content flex-1 min-h-0 space-y-6 overflow-y-auto px-1`,
                className,
            )}
        >
            {metaSection}
            <div
                className={cn(
                    `${prefix}-page min-h-0 w-full border-t border-border pt-6`,
                    pageClassName,
                )}
            >
                {page}
            </div>
        </div>
    );
}
